<template>
  <div class="evaluationBox">
    <div class="evaluateType">
    <span :class="{typeActive: currentType === 0}" @click="changeEvaType('全部', 0)">全部（{{evaluateTotal}}）</span>
    </div>
    <div class="evaluateList">
      <div class="evaluateItem" v-for="(item,index) of evaluateList" :key="index">
        <div class="leftAvatarBox">
          <img :src="item.avatar" alt="">
          <span>{{item.comment}}</span>
        </div>
        <div class="evaluateInfo">
          <p>{{item.comment}}</p>
          <div class="evaluateImgList">
            <div class="imgItemBox" v-for="(imgItem, index) of item.images" :key="index">
              <img :src="imgItem" alt="">
            </div>
          </div>
          <div class="evaluateTime">{{item.createTime}}</div>
          <div class="addToEvaInfo" v-if="item.addComment">
            <span>{追加评论}</span>
            <span>{{item.addComment}}</span>
          </div>
          <div class="evaluateImgList">
            <div class="imgItemBox" v-for="(imgItem, index) of item.addImages" :key="index">
              <img :src="imgItem" alt="">
            </div>
          </div>
          <div class="receiptTime" v-if="item.day">确认收货后{{item.day}}天追加</div>
        </div>
      </div>
      <el-pagination
        class="evaluationPage"
        background
        layout="prev, pager, next, jumper"
        :page-size="5"
        :current-page="listPage"
        @current-change="handleCurrentChange"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
export default {
  name: 'evaluation',
  mixins: [listSearchMixin],
  props: {
    evaluateParam: Object
  },
  data () {
    return {
      evaluateTotal: 0,
      evaluateList: [],
      currentType: 0,
      listPage: 1,
      currentWord: '全部',
      pageTotal: 0
    }
  },
  mounted () {
    this.getEvaluateList()
  },
  methods: {
    getEvaluateList () {
      let self = this
      let params = {
        url: api.getReplyList+'/'+self.currentPro.id,
        method: 'GET',
        payload: {
          page: 1,
          limit: 20,
          type:0,//0 查看全部 1好评
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          console.log(res);
           self.evaluateList = self.data;
          // self.evaluateParam.productId = self.data.productId
          // self.evaluateParam.words = self.data.words
          //self.similarProducts = self.data.similarProducts
        } else {
          self.$message(res.message)
        }
      })
      // let params = {
      //   url: api.getEvaluate,
      //   method: 'GET',
      //   payload: {
      //     productId: self.evaluateParam.productId,
      //     word: self.currentWord === '全部' ? '' : self.currentWord,
      //     page: self.listPage,
      //     pageSize: 5
      //   }
      // }
      // self.sendReq(params, (res) => {
      //   if (res.success) {
      //     self.evaluateList = res.data
      //     if (self.currentWord === '全部') {
      //       self.evaluateTotal = res.data.total
      //     }
      //     self.pageTotal = res.data.total
      //   } else {
      //     self.$message(res.message)
      //   }
      // })
    },
    // 切换评价类型
    changeEvaType (item, index) {
      this.listPage = 1
      this.currentType = index
      this.currentWord = item
      // console.log(this.currentWord, 'currentWord')
      this.getEvaluateList()
    },
    handleCurrentChange (val) {
      this.listPage = val
      this.getEvaluateList()
    }
  }
}
</script>

<style lang="scss" scoped>
.evaluationBox {
  .evaluateType {
    display: flex;
    span {
      height: 36px;
      line-height: 36px;
      width: 120px;
      border-radius: 18px;
      border: 1px solid #999999;
      text-align: center;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      margin-right: 20px;
      cursor: pointer;
    }
    .typeActive {
      border: 1px solid $mainColor;
      color: $mainColor;
    }
  }
  .evaluateList {
    margin-top: 25px;
    border-top: 1px solid #E5E5E5;
    margin-right: 8px;
    .evaluateItem {
      padding: 20px;
      margin-bottom: 15px;
      display: flex;
      border-bottom: 1px solid #E5E5E5;
      .leftAvatarBox {
        width: 100px;
        float: left;
        text-align: center;
        margin-right: 20px;
        img {
          width: 64px;
          height: 64px;
        }
        span {
          margin-top: 10px;
          color: #333333;
          font-size: 16px;
          display: block;
        }
      }
      .evaluateInfo {
        flex: 1;
        p {
          line-height: 25px;
          font-size: 16px;
          color: #333333;
          margin-bottom: 15px;
        }
        .evaluateTime {
          color: #999999;
          font-size: 16px;
          margin-bottom: 20px;
        }
        .addToEvaInfo {
          padding-top: 20px;
          border-top: 1px solid #E5E5E5;
          display: flex;
          margin-bottom: 15px;
          span {
            color: #999999;
            font-size: 16px;
            line-height: 25px;
          }
          span:nth-child(1) {
            margin-right: 15px;
          }
          span:nth-child(2) {
            flex: 1;
            color: #333333;
          }
        }
        .receiptTime {
          color: #999999;
          font-size: 16px;
        }
      }
      .evaluateImgList {
        display: flex;
        margin-bottom: 20px;
        .imgItemBox {
          width: 100px;
          height: 100px;
          background: #EEEEEE;
          display: flex;
          align-items: center;
          margin-right: 20px;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .evaluationPage {
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/evaluation.vue